// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"CheckboxInput_checkboxLabel__Iztt2","checkboxLabel__error":"CheckboxInput_checkboxLabel__error__e3S+v","hook":"CheckboxInput_hook__RRjyS"};